import React, {Dispatch, useEffect, useState} from "react";
import {Button} from "@varymadellc/my-weed-club-component-library";
import {next} from "stylis";

export interface ImageModalProps {
    images: Record<string, any>;
    selectedImageIndex: number;
    setIsOpen: Dispatch<any>;
    getImageCallback: (image: any) => any;
}

const guardIndex = (currentIndex: number, count: number) => {
    return currentIndex < 0 ? count - 1 : currentIndex % count;
};

export default function ImageModal({images, selectedImageIndex, getImageCallback}: ImageModalProps) {
    const [currentIndex, setCurrentIndex] = useState<number>(selectedImageIndex);

    const nextButtonRef = React.useRef<HTMLButtonElement>(null!);

    const lastButtonRef = React.useRef<HTMLButtonElement>(null!);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'ArrowRight') {
                const nextButton = document.getElementById('next-button');

                if (nextButton) {
                    nextButton.click();
                }
            } else if (event.key === 'ArrowLeft') {
                const lastButton = document.getElementById('last-button');

                if (lastButton) {
                    lastButton.click();
                }
            }
        }

        window.addEventListener('keydown', handleKeyDown);

        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [nextButtonRef?.current, lastButtonRef?.current, currentIndex, images?.length]);

    const guardedIndex = guardIndex(currentIndex, images.length);

    return (
        <div className="relative flex flex-1 flex-col justify-center border-secondary p-2">
            <div className="flex flex-row justify-end gap-2">
                {
                    guardedIndex > 0 && images.length > 1 &&
                    <Button id="last-button" onClick={() => setCurrentIndex(currentIndex - 1)}>Previous</Button>
                }
                {
                    images.length > 1 &&
                    <Button id="next-button" onClick={() => setCurrentIndex(currentIndex + 1)}>Next</Button>
                }
            </div>
            <div className="flex justify-center">
                {
                    images[guardedIndex] && <img src={getImageCallback(images[guardedIndex])} alt=""/>
                }
            </div>
        </div>
    );
}